import React from 'react'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function AddClient() {
    return (
        <>
            <Breadcrumb title="Add Client" path="Clients / Add Client" />
            <div className='bg-bg-dark rounded-lg shadow-light md:p-20 p-15'>
                <div className='grid grid-cols-12 gap-20'>
                    <div className='form-group lg:col-span-4 md:col-span-6 col-span-12'>
                        <input type='text' id='ClientFirstName' name='ClientFirstName' placeholder='First Name*' />
                    </div>
                    <div className='form-group lg:col-span-4 md:col-span-6 col-span-12'>
                        <input type='text' id='ClientLastName' name='ClientLastName' placeholder='Last Name' />
                    </div>
                    <div className='form-group lg:col-span-4 md:col-span-6 col-span-12'>
                        <input type='email' id='ClientEmail' name='ClientEmail' placeholder='Email ID*' />
                    </div>
                    <div className='form-group lg:col-span-4 md:col-span-6 col-span-12'>
                        <input type='text' id='ClientUsername' name='ClientUsername' placeholder='Username*' />
                    </div>
                    <div className='form-group lg:col-span-4 md:col-span-6 col-span-12'>
                        <input type='password' id='ClientPassword' name='ClientPassword' placeholder='Password*' />
                    </div>
                    <div className='form-group lg:col-span-4 md:col-span-6 col-span-12'>
                        <input type='password' id='ClientConfirmPassword' name='ClientConfirmPassword' placeholder='Confirm Password*' />
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <input type='number' id='ClientNumber' name='ClientNumber' placeholder='Mobile No' />
                    </div>
                    <div className='form-group lg:col-span-3 md:col-span-6 col-span-12'>
                        <input type='text' id='ClientId' name='ClientId' placeholder='Client ID*' />
                    </div>
                    <div className='form-group lg:col-span-6 col-span-12'>
                        <input type='text' id='ClientAddress' name='ClientAddress' placeholder='Address' />
                    </div>
                </div>
                <div>
                    <p className="text-[16px]/[19.2px] font-medium mt-30 mb-10">
                        Module Permission
                    </p>
                    <div className='overflow-auto'>
                        <table className='w-full min-w-[374px]'>
                            <thead>
                                <tr>
                                    <th align='left' className='bg-bg-light-100 p-3'>

                                    </th>
                                    <th align='center' className='bg-bg-light-100 p-3'>
                                        READ
                                    </th>
                                    <th align='center' className='bg-bg-light-100 p-3'>
                                        WRITE
                                    </th>
                                    <th align='center' className='bg-bg-light-100 p-3'>
                                        DELETE
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        Projects
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        Tasks
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        Chat
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                </tr>
                                <tr className='hover:bg-bg-light'>
                                    <td className='p-3 border-t border-border'>
                                        Estimates
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' defaultChecked />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                    <td align='center' className='p-3 border-t border-border'>
                                        <label className='cus-checkbox'>
                                            <input type='checkbox' />
                                            <span className='checkmark'></span>
                                        </label>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div className='border-t border-border pt-30'>
                    <button className='btn btn-primary'>
                        Add
                    </button>
                </div>
            </div>
        </>
    )
}
